import { render, staticRenderFns } from "./Resource copy.vue?vue&type=template&id=d6cdb7ca&scoped=true"
import script from "./Resource copy.vue?vue&type=script&lang=js"
export * from "./Resource copy.vue?vue&type=script&lang=js"
import style0 from "./Resource copy.vue?vue&type=style&index=0&id=d6cdb7ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6cdb7ca",
  null
  
)

export default component.exports